/*
 * @Author: Q in
 * @Date: 2025-11-13 11:45:08
 * @LastEditors: Q in 
 * @LastEditTime: 2026-05-21 18:07:07
 * @FilePath: /new_kefu_pc/src/router/index.js
 * @Description: 路由配置文件
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store/index';
import { isMobile } from '@/utils/validate.js';
Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Index',
		meta: {
			title: '客户端首页'
		}
	}
];

const router = new VueRouter({
	mode: 'history', // 启用 History 模式
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 每次路由跳转时，滚动到页面顶部
		return { x: 0, y: 0 };
	}
});

router.beforeEach((to, from, next) => {
	if (to.meta && to.meta.title) {
		document.title = '游戏账号租赁平台 - 快速找到心仪的游戏商品 -' + to.meta.title; // 设置动态标题
	}

	next();
});

export default router;
